<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20">
            <!-- <img
                class="w-8"
                src="assets/images/logo/logo.svg"
                alt="Logo image"> -->
        </div>
    </ng-container>
</fuse-vertical-navigation>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    @if(!this._router.url.includes('live-monitoring')){
    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full bg-green h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <div class="flex items-center pr-2 space-x-2">
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon class="text-black dark:text-slate-300" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button

                class="hidden md:inline-flex "
                mat-icon-button
                (click)="toggleNavigationAppearance()">
                <mat-icon class="text-black dark:text-slate-300"  [svgIcon]="'heroicons_outline:arrows-right-left'"></mat-icon>
            </button>
            <div class="text-xl font-bold tracking-tight leading-8">
                {{ currentPage }}
            </div>
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <div
            class="grid xs:grid-cols-6 sm:grid-cols-3 md:grid-cols-3 gap-6"
        >
            <!-- Dark/Light Mode Toggle -->
            <div
                class="flex items-center py-2 rounded-full cursor-pointer ring-inset ring-primary bg-hover justify-center"
                (click)="toggleScheme()"
            >
                <div class="flex items-center rounded-full overflow-hidden">
                    <mat-icon
                        class="icon-size-5"
                        [ngClass]="{
                            'mat-icon-color': config.scheme !== 'dark'
                        }"
                        [svgIcon]="
                            config.scheme === 'dark'
                                ? 'heroicons_solid:sun'
                                : 'heroicons_solid:moon'
                        "
                    ></mat-icon>
                </div>
                <div
                    class="flex items-center md:ml-2 sm:font-small md:font-medium leading-5"
                    [class.text-secondary]="config.scheme !== 'dark'"
                >
                    {{ config.scheme === "dark" ? "Light" : "Dark" }}
                </div>
            </div>
            <div class="flex items-center py-2 rounded-full cursor-pointer ring-inset ring-primary bg-hover justify-center">
                <button mat-menu-item>
                    <mat-icon
                        svgIcon="live_tv"
                        [ngClass]="{ 'mat-icon-color': config.scheme !== 'dark' }"
                    ></mat-icon>
                </button>
            </div>
            <div class="flex items-center py-2 rounded-full cursor-pointer ring-inset ring-primary bg-hover justify-center">
                <button
                    (click)="signOut()"
                    mat-menu-item
                    matTooltip="Sign out"
                >
                    <mat-icon
                        [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
                        [ngClass]="{ 'mat-icon-color': config.scheme !== 'dark' }"
                    ></mat-icon>
                    <!-- <span>Sign out</span> -->
                </button>
            </div>
        </div>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts>
            <messages></messages> -->
            <!-- <notifications></notifications> -->
            <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button> -->
           
            <user></user>
        </div>
    </div>
}

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>

</div>
<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
